import { render, staticRenderFns } from "./Page-Login.vue?vue&type=template&id=12e7156a"
import script from "./Page-Login.vue?vue&type=script&lang=js"
export * from "./Page-Login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports